
export const formatPrice = (price) => {
    const numericPrice = Number(String(price).replace(/[^0-9.-]+/g, ''));
  
    if (isNaN(numericPrice)) {
      return "0";
    }
  
    const hasDecimals = !Number.isInteger(numericPrice);
  
    return numericPrice.toLocaleString("en-US", {
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: hasDecimals ? 2 : 0,
    });
};